import PlanBTAddButtonPresenter from "./PlanBTAddButton/PlanBTAddButtonPresenter";
import PlanBTListPresenter from "./PlanBTList/PlanBTListPresenter";
import PlanBTSearchPresenter from "./PlantBTSearch/PlanBTSearchPresenter";

export const PlanBTList = {
    List : PlanBTListPresenter,
    InputSearch: PlanBTSearchPresenter,
    AddButton: PlanBTAddButtonPresenter
}